module.exports = __webpack_public_path__ + "static/33F324_6_0-8484ede89a479fe4e7674a948c9ecda8.woff";